import { createSlice } from "@reduxjs/toolkit"
import { initialState } from '../../initialState';


  
  export const taskDetailSlice = createSlice({
    name: 'taskDetail',
    initialState,
    reducers: {
      setTask:(state, action) => {
        state.task = action.payload
      }
      // openProjectEditModal:(state,action) => {
      //   state.projectEditModal = action.payload
      // },
      // closeProjectEditModal:(state) => {
      //   state.projectEditModal = {open:false}
      // },
      // openTaskEditModal:(state,action) => {
      //   state.taskEditModal = action.payload
      // },
      // closeTaskEditModal:(state) => {
      //   state.taskEditModal = {open:false}
      // }
    //   decrement: (state) => {
    //     state.value -= 1
    //   },
    },
  })
  
  export const { setTask } = taskDetailSlice.actions
  
  export default taskDetailSlice.reducer